import { apiCall } from '../util';

export const getStateByZipCode = async (zipCode) => {
  try {
    const stateValidationUrl = `purchase/State/GetStateByZipCode/${zipCode}`;
    const response = await apiCall(stateValidationUrl);
    const payload = await response.json();
    return {
      stateAbbr: payload?.Data?.StateAbbr || '',
      stateName: payload?.Data?.StateName || '',
    };
  } catch (error) {
    return {
      stateAbbr: '',
      stateName: '',
    };
  }
};
